



























import { Component, Prop, Vue } from "vue-property-decorator";
import {
  SameBuilding,
  SameBuildingGroup as SameBuildingGroupModel
} from "#/model/uniquemaster";
import SameBuildingGroupSelect from "@/components/master/office/SameBuildingGroupSelect.vue";

interface Option {
  text?: string;
  value?: string;
  header?: string;
  divider?: boolean;
  is_group?: boolean;
  same_building_id?: number;
  same_building_group_id?: number;
}

@Component({
  components: {
    SameBuildingGroupSelect
  }
})
export default class ComprehensiveSameBuildingSelect extends Vue {
  @Prop({ default: 0 }) sameBuildingId!: number;
  @Prop({ default: 0 }) sameBuildingGroupId!: number;
  @Prop({ default: () => [] }) sameBuildings!: SameBuilding[];
  @Prop({ default: () => [] }) sameBuildingGroups!: SameBuildingGroupModel[];
  @Prop({ default: false }) disabled!: boolean;
  @Prop({ default: false }) required!: boolean;

  private get internalRules(): Array<(v: string | null) => boolean | string> {
    if (!this.required) return [];
    return [
      () =>
        // 同一建物をチェック→ 同一建物グループをチェック→ エラーの順
        this.sameBuildingId > 0 ||
        this.sameBuildingGroupId > 0 ||
        "同一建物・同一建物グループを選択してください。"
    ];
  }

  private get options(): Option[] {
    const items: Option[] = [];
    items.push({ header: "同一建物グループ" });
    this.sameBuildingGroups.forEach(g => {
      items.push({
        text: g.name,
        value: `g_${g.id}`,
        is_group: true,
        same_building_id: 0,
        same_building_group_id: g.id
      });
    });
    items.push({ divider: true });
    items.push({ header: "同一建物" });
    this.sameBuildings.forEach(b => {
      items.push({
        text: b.display_name || b.name,
        value: `b_${b.id}`,
        is_group: false,
        same_building_id: b.id,
        same_building_group_id: 0
      });
    });
    return items;
  }

  private get currentValue(): string {
    if (this.sameBuildingGroupId > 0) return `g_${this.sameBuildingGroupId}`;
    if (this.sameBuildingId > 0) return `b_${this.sameBuildingId}`;
    return "";
  }

  private onInput(value: string | null) {
    // options に実データがない（初回ロード中）はリセット発火を抑止
    const hasData =
      this.sameBuildings.length > 0 || this.sameBuildingGroups.length > 0;
    if (!hasData) return;

    if (!value) {
      // 既に両方0なら無駄な更新を避ける
      if (this.sameBuildingId === 0 && this.sameBuildingGroupId === 0) return;
      this.updateSameBuildingId(0);
      this.updateSameBuildingGroupId(0);
      return;
    }
    const opt = this.options.find(o => o.value === value);
    if (!opt) return;
    if (opt.is_group) {
      this.updateSameBuildingId(0);
      this.updateSameBuildingGroupId(opt.same_building_group_id || 0);
    } else {
      this.updateSameBuildingId(opt.same_building_id || 0);
      this.updateSameBuildingGroupId(0);
    }
  }

  private updateSameBuildingId(id: number) {
    this.$emit("update:sameBuildingId", id);
    this.$emit("update:same-building-id", id);
  }

  private updateSameBuildingGroupId(id: number) {
    this.$emit("update:sameBuildingGroupId", id);
    this.$emit("update:same-building-group-id", id);
  }
}
